import React, { useEffect, useState } from "react";
import './Duration.scss';

type DurationProps = {
    className?: string,
    label?: string,
    value: string,
    disabled?: boolean,
    showHours?: boolean,
    onChange: (value: string) => void,
};

function Duration(props: DurationProps) {
    const [hours, setHours] = useState<number>(0);
    const [minutes, setMinutes] = useState<number>(5);
    const [seconds, setSeconds] = useState<number>(0);

    const getOptionLabel = (value: number): string => {
        return value < 10 ? `0${value}` : String(value);
    };
    
    useEffect(() => {
        let valueStr = `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
        if(props.showHours) {
            valueStr = `${hours < 10 ? `0${hours}` : hours}:${valueStr}`;
        }
        
        props.onChange(`${valueStr}`);
    }, [hours, minutes, seconds]);

    useEffect(() => {
        const data = props.value.split(':');

        if(data.length >= 3) {
            setHours(Number(data[0]));
            setMinutes(Number(data[1]));
            setSeconds(Number(data[2]));
        }
        else if(data.length === 2) {
            setMinutes(Number(data[0]));
            setSeconds(Number(data[1]));
        }
    }, [props.value]);

    return (
        <div className={`duration-container ${props.className}`}>
            {props.label && (
                <span className="duration-label">{props.label}</span>
            )}
            <div className="duration-container-selects">
                {props.showHours && (
                    <>
                        <select value={hours} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setHours(Number(e.target.value))} disabled={props.disabled}>
                            {new Array(24).fill(0).map((_, index: number) => (
                                <option key={index} value={index}>{getOptionLabel(index)}</option>
                            ))}
                        </select>:
                    </>
                )}
                <select value={minutes} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setMinutes(Number(e.target.value))} disabled={props.disabled}>
                    {new Array(60).fill(0).map((_, index: number) => (
                        <option key={index} value={index}>{getOptionLabel(index)}</option>
                    ))}
                </select>:
                <select value={seconds} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setSeconds(Number(e.target.value))} disabled={props.disabled}>
                    {new Array(60).fill(0).map((_, index: number) => (
                        <option key={index} value={index}>{getOptionLabel(index)}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default Duration;
